import { Logger, type WorkflowData, type WorkflowId } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { reportColumnKey } from '../keys'
import { workflowKey, workflowListKey } from './keys'
import { decorateWorkflow, type DecoratedWorkflowData } from './get'

const logger = new Logger('useWorkflowCache')

export function useWorkflowCache() {
  const queryClient = useQueryClient()
  return {
    clearList: () => {
      logger.verbose('invalidateQueries Workflows')
      queryClient.invalidateQueries({ queryKey: workflowListKey() })
    },
    addItem: (item: WorkflowData) => {
      logger.verbose('addItem Workflow', item)
      queryClient.setQueryData<WorkflowData[]>(workflowListKey(), (old) => [...(old || []), item])
      queryClient.setQueryData<DecoratedWorkflowData>(workflowKey(item.workflowId), decorateWorkflow(item))
    },
    replaceItem: (item: WorkflowData) => {
      logger.verbose('replaceItem Workflow', item)
      queryClient.setQueryData<WorkflowData[]>(workflowListKey(), (old) => {
        if (!old) return
        return old.map((t) => (t.workflowId === item.workflowId ? item : t))
      })
      queryClient.setQueryData<DecoratedWorkflowData>(workflowKey(item.workflowId), decorateWorkflow(item))
    },
    removeItem: (workflowId: WorkflowId) => {
      logger.verbose('removeItem Workflow', workflowId)
      queryClient.setQueryData<WorkflowData[]>(workflowListKey(), (old) =>
        old?.filter((t) => t.workflowId !== workflowId)
      )
      queryClient.removeQueries({ queryKey: workflowKey(workflowId) })
    },
    setItem: (item: WorkflowData) => {
      logger.verbose('setItem Workflow', item)
      queryClient.setQueryData<DecoratedWorkflowData>(workflowKey(item.workflowId), decorateWorkflow(item))
    },
    clearReportColumns: () => {
      logger.verbose('invalidateQueries reportColumnKey')
      queryClient.invalidateQueries({ queryKey: reportColumnKey() })
    },
  }
}
